import { render, staticRenderFns } from "./StartupsGrid.vue?vue&type=template&id=1d0d3f3c&scoped=true&"
import script from "./StartupsGrid.vue?vue&type=script&setup=true&lang=js&"
export * from "./StartupsGrid.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0d3f3c",
  null
  
)

export default component.exports